import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { useTheme } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialIcons';
import FontAwesome from '@expo/vector-icons/FontAwesome';
import { QText } from './index';

const CompactQuantitySelector = ({
  quantity,
  onQuantityChange,
  onRemove,
  maxQuantity = 999,
  minQuantity = 1,
  style,
}) => {
  const theme = useTheme();

  const styles = {
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: theme.colors.onBackground,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: theme.colors.borderColor,
      paddingHorizontal: 4,
      paddingVertical: 2,
      ...style,
    },
    button: {
      width: 36,
      height: 36,
      borderRadius: 6,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.colors.primary,
    },
    buttonDisabled: {
      backgroundColor: theme.colors.borderColor,
    },
    buttonText: {
      fontSize: 18,
      color: theme.colors.whiteTxt,
      fontWeight: '600',
    },
    buttonTextDisabled: {
      color: theme.colors.placeHolderText,
    },
    quantityDisplay: {
      minWidth: 40,
      paddingHorizontal: 12,
      justifyContent: 'center',
      alignItems: 'center',
    },
    quantityText: {
      fontSize: 16,
      color: theme.colors.secondaryText,
      fontWeight: '600',
    },

    removeButton: {
      width: 28,
      height: 28,
      borderRadius: 4,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#FF4444',
      marginLeft: 6,
    },
  };

  const handleDecrease = () => {
    if (quantity > minQuantity) {
      onQuantityChange(quantity - 1);
    }
  };

  const handleIncrease = () => {
    if (quantity < maxQuantity) {
      onQuantityChange(quantity + 1);
    }
  };

  const handleRemove = () => {
    onRemove();
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={[
          styles.button,
          quantity <= minQuantity && styles.buttonDisabled,
        ]}
        onPress={handleDecrease}
        disabled={quantity <= minQuantity}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        activeOpacity={0.7}
      >
        <QText
          style={[
            styles.buttonText,
            quantity <= minQuantity && styles.buttonTextDisabled,
          ]}
        >
          -
        </QText>
      </TouchableOpacity>

      <View style={styles.quantityDisplay}>
        <QText style={styles.quantityText}>{quantity}</QText>
      </View>

      <TouchableOpacity
        style={[
          styles.button,
          quantity >= maxQuantity && styles.buttonDisabled,
        ]}
        onPress={handleIncrease}
        disabled={quantity >= maxQuantity}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        activeOpacity={0.7}
      >
        <QText
          style={[
            styles.buttonText,
            quantity >= maxQuantity && styles.buttonTextDisabled,
          ]}
        >
          +
        </QText>
      </TouchableOpacity>

      {quantity === 1 && (
        <TouchableOpacity
          style={styles.removeButton}
          onPress={handleRemove}
          hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          activeOpacity={0.7}
        >
          <FontAwesome name="times" size={12} color="white" />
        </TouchableOpacity>
      )}
    </View>
  );
};

export default CompactQuantitySelector;
